import Button from "./Button";

export default Button;
export type { RUICButtonVariants, SBButtonVariants } from "./Button.d";
